import * as React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { Home } from "./screens/Home";
import { Category } from "./screens/Category";
import { SubCategory } from "./screens/SubCategory";
import { Article } from "./screens/Article";
import { BASE_PATH } from "./helpers/router.helper";
import { AppContextConsumer, IAppContext } from "./AppContext";

export enum Slug {
  category = "category",
  subCategory = "subCategory",
  articleName = "articleName",
  articleId = "articleId",
}

export type UseParamsType = Record<Slug, string>;

export const Router = () => (
  <AppContextConsumer>
    {(appContext: IAppContext) => (
      <Switch>
        <Route exact path={BASE_PATH}>
          <Home context={appContext} />
        </Route>
        <Route exact path={`${BASE_PATH}/:${Slug.category}`}>
          <Category context={appContext} />
        </Route>
        <Route
          exact
          path={`${BASE_PATH}/:${Slug.category}/:${Slug.subCategory}`}
        >
          <SubCategory context={appContext} />
        </Route>
        <Route
          exact
          path={`${BASE_PATH}/:${Slug.category}/:${Slug.subCategory}/:${Slug.articleName}/:${Slug.articleId}`}
        >
          <Article context={appContext} />
        </Route>
        <Redirect to={BASE_PATH} />
      </Switch>
    )}
  </AppContextConsumer>
);
